const GAUGE_GRADIENT_ID = "vybe-gauge-gradient";

function polarPoint(cx, cy, r, angleDeg) {
  const rad = (angleDeg * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
}

function arcPath(cx, cy, r, startAngle, endAngle) {
  const start = polarPoint(cx, cy, r, startAngle);
  const end = polarPoint(cx, cy, r, endAngle);
  return `M ${start.x} ${start.y} A ${r} ${r} 0 0 1 ${end.x} ${end.y}`;
}

// Speedometer-style gauge: 180deg sweep, needle rotates from 180deg (min) to 0deg (max).
export function GaugeChart({ value, min = 0, max = 100, displayValue, label, dark = true }) {
  const pct = Math.max(0, Math.min(1, (value - min) / (max - min || 1)));
  const needleAngle = 180 - pct * 180;
  const cx = 100;
  const cy = 96;
  const r = 78;
  const needleTip = polarPoint(cx, cy, r - 14, needleAngle);

  const trackColor = dark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.08)";
  const labelColor = dark ? "#fff" : "#0F172A";
  const mutedColor = dark ? "#94A3B8" : "#64748B";

  return (
    <div className="flex flex-col items-center justify-center h-full" data-testid="gauge-chart">
      <svg viewBox="0 0 200 120" className="w-full max-w-[420px]" style={{ filter: "drop-shadow(0 0 18px rgba(139,92,246,0.35))" }}>
        <defs>
          <linearGradient id={GAUGE_GRADIENT_ID} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="55%" stopColor="#06B6D4" />
            <stop offset="100%" stopColor="#10B981" />
          </linearGradient>
        </defs>
        <path d={arcPath(cx, cy, r, 180, 0)} fill="none" stroke={trackColor} strokeWidth="14" strokeLinecap="round" />
        <path
          d={arcPath(cx, cy, r, 180, needleAngle)}
          fill="none"
          stroke={`url(#${GAUGE_GRADIENT_ID})`}
          strokeWidth="14"
          strokeLinecap="round"
          className="gauge-progress-glow"
        />
        <line x1={cx} y1={cy} x2={needleTip.x} y2={needleTip.y} stroke={labelColor} strokeWidth="3.5" strokeLinecap="round" data-testid="gauge-needle" />
        <circle cx={cx} cy={cy} r="7" fill="#8B5CF6" stroke={labelColor} strokeWidth="1.5" />
      </svg>
      <div className="text-center -mt-2" data-testid="gauge-value">
        <p
          className="font-bold"
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "clamp(28px, 4.2vw, 42px)",
            background: "linear-gradient(90deg, #8B5CF6, #06B6D4)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          {displayValue}
        </p>
        {label && (
          <p className="font-body text-sm md:text-base mt-1" style={{ color: mutedColor }} data-testid="gauge-label">
            {label}
          </p>
        )}
      </div>
    </div>
  );
}
